import { Dispatch, SetStateAction } from 'react';
import Lang from 'types/Lang';
import IUser from 'types/superadmin/ISuperAdmin';
import { escapeRegExp } from 'utils/helpers';

// LanguageId is 1-based (1 = nl, 2 = fr, 3 = en). Anything else means "no language configured".
export const getLanguageLabel = (languageId: number | string): string => {
  const languages = Object.values(Lang);
  const index = Number(languageId) - 1;
  return languages[index] ?? '';
};

export const handleGridSearch = (searchTerm: string, users: IUser[], setRows: Dispatch<SetStateAction<IUser[]>>) => {
  if (searchTerm) {
    const searchRegex = new RegExp(escapeRegExp(searchTerm), 'i');
    const filteredRows = users.filter((row: IUser) => {
      return Object.keys(row).some((field: string) => {
        return searchRegex.test(row[field]);
      });
    });
    setRows(filteredRows);
  } else {
    setRows(users);
  }
};
